import { Goal } from '@/types/financial';
import { useMemo } from 'react';

export const useGoalSelectors = (goals: Goal[]) => {
  return useMemo(() => ({
    getById: (id: string) =>
      goals.find(g => g.id === id),
    
    getByCategory: (category: string) =>
      goals.filter(g => g.category === category),
    
    getActive: () =>
      goals,
    
    getCompleted: () =>
      goals.filter(g => {
        const progress = ((g.currentValue || 0) / g.targetValue) * 100;
        return progress >= 100;
      }),
    
    getProgress: (goalId: string) => {
      const goal = goals.find(g => g.id === goalId);
      if (!goal) return 0;
      return ((goal.currentValue || 0) / goal.targetValue) * 100;
    },
    
    getTotalTarget: () =>
      goals.reduce((sum, g) => sum + g.targetValue, 0),
    
    getTotalCurrent: () =>
      goals.reduce((sum, g) => sum + (g.currentValue || 0), 0),
  }), [goals]);
};
